import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CommonEvents } from '../../enums/common-events.enum';
import { filter, map } from 'rxjs/operators';

interface BroadcastEvent {
    key: CommonEvents;
    data?: any;
}

@Injectable({
    providedIn: 'root'
})
export class BroadcastService {

    private eventBus: Subject<BroadcastEvent>;

    constructor() {
        this.eventBus = new Subject<BroadcastEvent>();
    }

    public broadcast(key: any, data?: any) {
        this.eventBus.next({key, data});
    }

    /**
     * Observable for events defined by identification key
     * @param key event identification
     */
    public on<T>(key: any): Observable<T> {
        return this.eventBus.asObservable()
            .pipe(filter(event => event.key === key))
            .pipe(map(event => event.data as T));
    }
}
